<template>
  <div class="text-center mb-6">
    <h2 class="text-2xl md:text-3xl font-bold text-primary-dark mb-3">
      Qual é seu nome completo?
    </h2>
    <p class="text-gray-600">
      Seu nome é a chave para revelar seu propósito através da numerologia
    </p>
  </div>
</template>